<template>
  <v-container class="text-center">
    <v-row align="center" justify="center">
      <v-col cols="10">
        <v-row align="center" justify="center">
          <v-col cols="12" md="4">
            <div>
              <span style="margin-left: -70px" class="body-1">Contact</span>
              <br /><br />
              <v-btn
                v-for="icon in contact"
                :key="icon"
                class="mx-1"
                fab
                small
                dark
              >
                <v-icon size="24px">
                  {{ icon }}
                </v-icon>
              </v-btn>
            </div>
          </v-col>
          <v-col cols="12" md="4">
            <v-card-text>
              <span style="margin-left: -160px" class="body-1">Follow Us</span>
              <br /><br />
              <v-btn
                v-for="icon in rrss"
                :key="icon"
                class="mx-1"
                fab
                small
                dark
              >
                <v-icon size="24px">
                  {{ icon }}
                </v-icon>
              </v-btn>
            </v-card-text>
          </v-col>
          <v-col cols="12" md="4">
            <br />
            <v-card-text class="body-1">
              © 2024 IAP Research Symposia
            </v-card-text>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      contact: ["mdi-phone", "mdi-email", "mdi-map-marker"],
      rrss: [
        "mdi-facebook",
        "mdi-instagram",
        "mdi-whatsapp",
        "mdi-twitter",
        "mdi-linkedin"
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
</style>